import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpService } from 'src/service/http.service';
import Swal from 'sweetalert2';
import * as CryptoJS from "crypto-js";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  tokenFromUI: string = "17eba9787a50e18b23d3";

  ngOnInit(): void {
  }
model: any = {};
  fieldTextType: boolean;
  fieldTextType1: boolean;
  show: boolean = true;
  submitLoader: boolean = true;
  constructor(
    private _httpservice:HttpService,
    private _router:Router
    ) { }


  onResetPassword(form: NgForm) {
    
    if (form.valid) {
    
      let ciphertext = CryptoJS.AES.encrypt(form.value.password, this.tokenFromUI).toString();

      var passwordObj={
        // password:form.value.password,
        // user_verify:1,
        // user_id:userID
        "email": localStorage.getItem('email'),
        "password":ciphertext
      }
    this._httpservice.changePassword(passwordObj).subscribe(res => {
      // localStorage.clear();
      // this._router.navigate(['sign-in'])


      if(res['responseCode'] === 0){
        Swal.fire({
    
          html: `<h5 class="sub-head">Password changed Successfully taking you to Login screen.</h5>`,
                
          icon: 'success',
          confirmButtonText: 'OK',
              customClass: {
                container: 'my-swal',
                confirmButton: 'your-confirm-button-class-password',
  
              }
        }).then((result) => {
          // this.router.navigate(['otp'])
          this._router.navigate(['sign-in'])
          localStorage.clear();
        });
      } else {

       Swal.fire({
              html: `<h6 class="head">Error!<h6><h5 class="sub-head">${res['responseData']}</h5>`,
              icon: "error",
              confirmButtonText: "OK",
              customClass: {
                container: "my-swal",
                confirmButton: "your-confirm-button-class",
              },
            }).then((result) => {
              localStorage.clear();
              this._router.navigate(['sign-in'])
            })
     
    
    }
    })
  }
  }
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
  toggleFieldTextType1() {
    this.fieldTextType1 = !this.fieldTextType1;
  }
}
